"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SteelCasting = void 0;
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var Resources_1 = require("../../../Resources");
var Card_1 = require("../../Card");
var CardRenderer_1 = require("../../render/CardRenderer");
var SteelCasting = (function (_super) {
    __extends(SteelCasting, _super);
    function SteelCasting() {
        return _super.call(this, {
            cost: 3,
            name: CardName_1.CardName.STEEL_CASTING,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'L408',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.steel(1); });
                }),
                description: 'Increase your Steel production 1 step.',
            },
        }) || this;
    }
    SteelCasting.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.STEEL, 1);
        return undefined;
    };
    return SteelCasting;
}(Card_1.Card));
exports.SteelCasting = SteelCasting;
//# sourceMappingURL=SteelCasting.js.map